import { useState } from "react";
import { OncologySubmissionApiResponse } from "../../../api/bigQuery/oncologySubmissionOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";

export interface AsteraOncologyExternalTableState {
  data: OncologySubmissionApiResponse | undefined;
  loading: boolean;
  error: string | null;
  showInlineLoader: boolean;
}

export interface UseAsteraOncologyExternalTableDataReturn {
  asteraOncologyExternalState: AsteraOncologyExternalTableState;
  setAsteraOncologyExternalState: React.Dispatch<
    React.SetStateAction<AsteraOncologyExternalTableState>
  >;
  tableData: PharmaStpFileModel[];
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>;
}

export const useAsteraOncologyExternalTableData =
  (): UseAsteraOncologyExternalTableDataReturn => {
    const [tableData, setTableData] = useState<PharmaStpFileModel[]>([]);
    const [asteraOncologyExternalState, setAsteraOncologyExternalState] =
      useState<AsteraOncologyExternalTableState>({
        data: undefined,
        loading: false,
        error: null,
        showInlineLoader: false,
      });

    return {
      asteraOncologyExternalState,
      setAsteraOncologyExternalState,
      tableData,
      setTableData,
    };
  };
